import React from 'react';
import {Route,Redirect } from "react-router-dom";
    
const SecuredRoute = ({ component: Component, layout:Layout, authenticated, ...rest}) => 
(
  
    <Route
    {...rest} 
      render={props =>         
        authenticated ? (          
         <Layout component={Component} {...rest} {...props}/>                                                            
        )        
        : (
          <Redirect         
            to={{
              pathname: '/',
              state: { from: props.location }              
            }}           
          />
        )
      }
    /> 
    
    
);

export default SecuredRoute;